import { get as lodashGet } from "lodash-es";
import { useInstanceConfigQuery } from "@certa/queries/hooks/config.hook";

export const useIsNewNavigationEnabled = (): boolean => {
  const { data: config } = useInstanceConfigQuery();
  const isNewNavigationEnabled = lodashGet(
    config,
    "custom_ui_labels.feature_toggles.NEW_NAVIGATION_STANDARD",
    false
  );

  return isNewNavigationEnabled;
};
